import ChallengeItem from './ChallengeItem';

export default ChallengeItem;
